import { render } from "./newLogo.vue?vue&type=template&id=837b7d72"
const script = {}

import exportComponent from "/home/forge/pa.aneto-apps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__